import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromPassengersDetails from './passengers-details.reducer';
import {getRouterState} from '@ibe/store/.';

export class State {
	passengersDetails: fromPassengersDetails.State;
}

export * from './passengers-details.actions';
export * from './passengers-details.reducer';

export const getStatePassengersDetails = createFeatureSelector<fromPassengersDetails.State>('passengersDetails');
export const getSelectedBookedTripLoading = createSelector(getStatePassengersDetails, fromPassengersDetails.getLoading);
export const getSelectedBookedTrip = createSelector(getStatePassengersDetails, fromPassengersDetails.getBookedTrip);
export const getSelectedBookedTripInfoPax = createSelector(getSelectedBookedTrip, fromPassengersDetails.getInfoPax);
export const getSelectedDocumentTypes = createSelector(getStatePassengersDetails, fromPassengersDetails.getDocumentTypes);
export const getSelectedFrequentFlyerPrograms = createSelector(getStatePassengersDetails, fromPassengersDetails.getFrequentFlyerPrograms);
export const getSelectedAnyFormHasChanges = createSelector(getStatePassengersDetails, fromPassengersDetails.isFormChanges);
export const getSelectedNotif = createSelector(getStatePassengersDetails, fromPassengersDetails.getNotif);

export const getSelectedBookedTripFare = createSelector(getSelectedBookedTrip, fromPassengersDetails.getFare);
export const getSelectedPassengers = createSelector(getSelectedBookedTrip, fromPassengersDetails.getPassengers);
export const getSelectedPassengersAtIndex = createSelector(getSelectedPassengers, getRouterState, fromPassengersDetails.getPassengerAtIndex);
export const getSelectedEmergencyData = createSelector(getSelectedPassengersAtIndex, fromPassengersDetails.getEmergencyData);

export const getSelectedBookedTripLocations = createSelector(getSelectedBookedTrip, fromPassengersDetails.getLocations);
